<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i>生产管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-form ref="searchform" :model="searchform" label-width="100px" @keyup.enter.native="search()">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="入库单编号" prop="receiptNo">
                                <el-input v-model.trim="searchform.receiptNo" style="width: 100%" clearable
                                    placeholder="请输入入库单编号" />
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="6">
                            <el-form-item label="产品编码" prop="productCode">
                                <el-input v-model.trim="searchform.productCode" style="width: 100%" clearable
                                    placeholder="请输入产品编码" />
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="6">
                            <el-form-item label="状态" prop="status">
                                <el-select style="width: 100%;" v-model="searchform.status" placeholder="请选择状态">
                                    <el-option label="未确认" :value="0"></el-option>
                                    <el-option label="已确认" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="入库日期" prop="datelist">
                                <el-date-picker style="width: 100%" v-model="searchform.datelist" type="daterange"
                                    value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期"
                                    end-placeholder="结束日期" :clearable='false'></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-button type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
                            <el-button @click="resetForm('searchform')">重置</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <br />
            <el-row type="flex" class="row-bg">
                <el-col :span="24" class="border">
                    <h4>{{ $route.meta.title }}</h4>
                    <el-divider></el-divider>
                    <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData"
                        style="width: 100%" id="parent">
                        <el-table-column prop="receiptNo" label="入库单编号" min-width="130" show-overflow-tooltip />
                        <el-table-column prop="qrCode" label="码" min-width="220" show-overflow-tooltip />
                        <el-table-column prop="productName" label="产品名称" min-width="150" show-overflow-tooltip />
                        <el-table-column prop="packageLevel" label="包装级别" min-width="70" show-overflow-tooltip />
                        <el-table-column prop="batchNo" label="生产批次" min-width="120" show-overflow-tooltip />
                        <el-table-column prop="numRelation" label="数量" min-width="70" show-overflow-tooltip />
                        <el-table-column prop="qrCodeParent" label="父级码" min-width="170" show-overflow-tooltip />
                        <el-table-column prop="pdaIdent" label="PDA唯一码" min-width="150" show-overflow-tooltip />
                        <el-table-column prop="scanUnitCode" label="单位编码" min-width="70" show-overflow-tooltip />
                        <el-table-column prop="scanUnitName" label="单位名称" min-width="70" show-overflow-tooltip />
                        <el-table-column prop="status" label="状态" min-width="80" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.status == 0 ? '' : 'success'">{{
                                    statusList[scope.row.status] }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="scanTime" label="扫码时间" min-width="140" show-overflow-tooltip>
                            <template slot-scope="scope">{{ $parseTime(scope.row.scanTime) }}</template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" min-width="140" show-overflow-tooltip>
                            <template slot-scope="scope">{{ $parseTime(scope.row.createTime) }}</template>
                        </el-table-column>
                        <el-table-column prop="scanQuantity" label="扫码数量" min-width="70" show-overflow-tooltip />
                    </el-table>
                    <br />
                    <el-pagination background @current-change="currentchange" @size-change="searchform.pageSize"
                        :current-page.sync="searchform.pageIndex" :page-sizes="[10, 20, 30, 50]"
                        layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import { receiptScanList } from "@/api/production";
//引入导出组件模块 
export default {
    mounted() {
        //请求部门列表数据并且便利到表格
        this.search();
    },
    data() {
        return {
            //基础数据
            listLoading: false,
            tableData: [],
            //分页数据
            pageSize: "",
            total_count: 0,
            receiptTypeList: ['生产入库', '调拨入库', '退货入库'],
            receiptSourceList: ['后台建单', 'PDA建单',],
            statusList: ['未确认', '已确认',],
            searchform: {
                pageSize: 10,
                pageIndex: 1,
                productCode: null,
                receiptNo: null,
                status: null,
                datelist: [],
            },
        };
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.search()
        },
        //请求表格数据
        Tabledata(obj) {
            this.listLoading = true;
            this.searchform.beginDate = this.searchform.datelist == null ? "" : this.searchform.datelist[0];
            this.searchform.endDate = this.searchform.datelist == null ? "" : this.searchform.datelist[1];
            receiptScanList(obj).then((response) => {
                this.tableData = response.data.items;
                this.total_count = response.data.total_count;
                this.searchform.pageIndex = response.data.currPage;
                this.listLoading = false;
            });
        },

        //搜索事件
        search() {
            this.searchform.pageIndex = 1;
            this.Tabledata(this.searchform);
        },
        //分页跳转事件
        currentchange(page) {
            this.searchform.pageIndex = page;
            this.Tabledata(this.searchform);
        },
        //分页每页显示条数事件
        limit(limit) {
            this.searchform.pageSize = limit;
            this.search();
        },
    },
};
</script>
<style scoped></style>